import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens({ commit }) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("wkf/item", {
        headers
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        return resp.data;
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Store({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "wkf/item",
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Update({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "put",
      url: "wkf/item/" + params.id,
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Delete({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("wkf/item/" + params.id, {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Tabela({ commit }) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("wkf/tabela", {
        headers
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setTabela", resp.data.tabela);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Coluna({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("wkf/coluna", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setColuna", resp.data.coluna);
      })
      .catch(() => {
        // Helpers.logout();
      });
  }
};
